'use strict';

/* globals jQuery yith yithStripePayments */

import { $ } from '../../../src/globals';
import AjaxHandler from '../../../src/modules/ajax';

/**
 * Class that handles Onboarding button interactions
 */
export default class OnboardingButton {
	/**
	 * Set of options
	 */
	options = {
		reloadOnClose: true,
		addBackdrop: true,
	};

	/**
	 * jQuery button element
	 */
	$button;

	/**
	 * Instance of the popup window opened to contain onboard flow
	 */
	onboardingPopup;

	/**
	 * Holds reference to the Interval checking for onboarding popup closure
	 */
	popupClosePool;

	/**
	 * Constructor method
	 *
	 * @param {jQuery} $el     Object jQuery reference to onboarding button node
	 * @param {Object} options Options for object construction
	 */
	constructor( $el, options = {} ) {
		this.$button = $el;
		this.options = { ...this.options, ...options };

		this.init();
	}

	/**
	 * Init events specific of this object
	 */
	init() {
		this.initClick();
	}

	/**
	 * Init click on the Onboarding button
	 */
	initClick() {
		this.$button.on( 'click', ( ev ) => {
			ev.preventDefault();
			this.onClick();
		} );
	}

	/**
	 * Handles click on the onboarding button
	 */
	onClick() {
		AjaxHandler.post
			.call( this.$button, 'process_onboarding', 'process_onboarding', {
				env: this.getEnv(),
			} )
			.then( ( response ) => {
				// something went wrong with connection process; reload to show possible notices.
				if ( ! response?.data?.onboard_link ) {
					return window.location.reload();
				}

				this.openOnboardingWindow( response.data.onboard_link );
			} );
	}

	/**
	 * Returns env for API call (either global defined one, or one coming from dedicated option in current page)
	 *
	 * @return {string} Current environment
	 */
	getEnv() {
		const $envRadio = $( ':input[id*="environment"]' ),
			$checked = $envRadio.filter( ':checked' ),
			val = $checked.val();

		let env = yithStripePayments.env;

		if ( val && [ 'live', 'test' ].includes( val ) ) {
			env = val;
		}

		return env;
	}

	/**
	 * Adds backdrop to current window
	 */
	addBackdrop() {
		this.options.addBackdrop &&
			$( document.body ).addClass( 'stripe-onboarding-open' );
	}

	/**
	 * Removes backdrop from current window
	 */
	removeBackdrop() {
		this.options.addBackdrop &&
			$( document.body ).removeClass( 'stripe-onboarding-open' );
	}

	/**
	 * Opens onboarding popup, given the URL to visit
	 *
	 * @param {string} onboardLink Url to visit for onboarding
	 */
	openOnboardingWindow( onboardLink ) {
		const screenHeight = screen.height,
			screenWidth = screen.width,
			features = Object.entries( {
				popup: true,
				left: screenWidth / 6,
				top: screenHeight / 6,
				width: ( 2 * screenWidth ) / 3,
				height: ( 2 * screenHeight ) / 3,
			} )
				.map( ( [ i, v ] ) => `${ i }=${ v }` )
				.join( ',' );

		// open popup window.
		this.onboardingPopup = window.open( onboardLink, 'Stripe', features );

		// starts timeout to check for window closure.
		this.startPopupClosePool();

		// add backdrop on body
		this.addBackdrop();
	}

	/**
	 * Starts the pool that checks for onboarding popup closure
	 */
	startPopupClosePool() {
		if ( this.popupClosePool ) {
			clearInterval( this.popupClosePool );
		}

		this.popupClosePool = setInterval( () => {
			if ( ! this.onboardingPopup.closed ) {
				return;
			}

			this.onboardingPopup = null;
			this.removeBackdrop();

			clearInterval( this.popupClosePool );

			this.options.reloadOnClose && window.location.reload();
		}, 1000 );
	}

	/**
	 * Removes event listeners and cleans up resources.
	 */
	destroy() {
		this.$button.off();
	}
}
